import React from 'react';
import PropTypes from 'prop-types';

const ListMessage = (props) => {
  return(
    <ul className="list">
      { props.messages.map((message, index) => <li key={`ListMessage_${index}`} className="list-item">{message}</li>) }
    </ul>
  );
};

ListMessage.propTypes = {
  messages: PropTypes.array.isRequired
};

export default ListMessage;